module.exports = __webpack_public_path__ + "img/xpz_common.1041bfcc.png";